import request from '@/utils/request'

/**
 * 创建纪念馆初始数据获取
 *
 * @export
 * @returns
 */
export function getCreateData() {
  return request({
    url: '/Api/Personal/Hall/CreateInitData',
    method: 'POST'
  })
}

/**
 * 祭词模板列表获取
 *
 * @export
 * @returns
 */
export function getOrationTemplate({ kw, pageIndex, pageSize }) {
  return request({
    url: `/Api/Personal/Hall/OrationTemplate?kw=${kw}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'POST'
  })
}

/**
 * 创建纪念馆
 *
 * @export
 * @param {Object} data 创建需要的数据
 * @returns
 */
export function createHall(data) {
  return request({
    url: '/Api/Personal/Hall/Create',
    method: 'POST',
    data: data
  })
}

/**
 * 获取我创建的纪念馆数据
 *
 * @export
 * @returns
 */
export function getCreatedHall() {
  return request({
    url: '/Api/Personal/Hall/MyCreated',
    method: 'POST'
  })
}

/**
 * 纪念馆开启关闭设置
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {boolean} isOpen 是否开启
 * @returns
 */
export function setCreatedHallOpen(hallId, isOpen) {
  return request({
    url: `/Api/Personal/Hall/Setup?hallId=${hallId}&isOpen=${isOpen}`,
    method: 'POST'
  })
}

/**
 * 编辑纪念馆信息
 *
 * @export
 * @param {Object} data 编辑需要的数据
 * @returns
 */
export function editHall(data) {
  return request({
    url: '/Api/Personal/Hall/Edit',
    method: 'POST',
    data: data
  })
}

/** 获取纪念馆亲友管理信息
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} pageIndex 当前页码
 * @param {number} pageSize 分页大小
 * @returns
 */
export function getHallRelativeData(hallId, pageIndex = 1, pageSize = 10) {
  return request({
    url: `/Api/Personal/Hall/Relative/List?hallId=${hallId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'POST'
  })
}

/** 纪念馆亲友解绑
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} id 亲友id
 * @returns
 */
export function unbindHallRelative(hallId, id) {
  return request({
    url: `/Api/Personal/Hall/Relative/Unbind?hallId=${hallId}&id=${id}`,
    method: 'POST'
  })
}

/** 纪念馆亲友绑定
 *
 * @export
 * @param {number} id 亲友id
 * @param {boolean} result true|false
 * @returns
 */
export function auditHallRelative(id, result) {
  return request({
    url: `/Api/Personal/Hall/Relative/Audit?id=${id}&result=${result}`,
    method: 'POST'
  })
}

/** 纪念馆亲友绑定-手机
 *
 * @export
 * @param {string} phone 手机号码
 * @param {Integer} hallId 纪念馆Id
 * @returns
 */
export function bindHallRelative(phone, hallId) {
  return request({
    url: `/Api/Personal/Hall/Relative/Bind?phone=${phone}&hallId=${hallId}`,
    method: 'POST'
  })
}

/** 纪念馆亲友删除
 *
 * @export
 * @param {number} id 亲友id
 * @returns
 */
export function deleteHallRelative(id) {
  return request({
    url: `/Api/Personal/Hall/Relative/Delete?id=${id}`,
    method: 'POST'
  })
}

/**
 * 升级纪念馆页面数据
 *
 * @export
 * @returns
 */
export function getUpgradeHallData() {
  return request({
    url: '/Api/Personal/Hall/UpGradePageData',
    method: 'POST'
  })
}

/**
 * 升级纪念馆级别
 *
 * @export
 * @param {number} id 纪念馆id
 * @param {number} levelId 纪念馆等级id
 * @returns
 */
export function UpgradeHallLevel(id, levelId) {
  return request({
    url: `/Api/Personal/Hall/UpGrade?id=${id}&levelId=${levelId}`,
    method: 'POST'
  })
}

/**
 * 转交纪念馆
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} phone 转交用户的平台注册手机号
 * @returns
 */
export function HallTransfer(hallId, phone) {
  return request({
    url: `/Api/Personal/Hall/Transfer?hallId=${hallId}&phone=${phone}`,
    method: 'POST'
  })
}

/**
 * 删除纪念馆
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @returns
 */
export function HallDelete(hallId) {
  return request({
    url: `/Api/Personal/Hall/delete?hallId=${hallId}`,
    method: 'POST'
  })
}

/**
 * 管理纪念馆文章
 *
 * @export
 * @param {number} id 纪念馆id
 * @param {number} pageIndex 当前页码
 * @param {number} pageSize 分页大小
 * @returns
 */
export function getHallArticleData(id, pageIndex = 1, pageSize = 10) {
  return request({
    url: `/Api/Personal/Hall/Article/List?id=${id}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'POST'
  })
}

/**
 * 创建纪念馆文章
 *
 * @export
 * @param {JSON} data 纪念馆文章数据
 * @returns
 */
export function createHallArticle(data) {
  return request({
    url: '/Api/Personal/Hall/Article/Create',
    method: 'POST',
    data: data
  })
}

/**
 * 编辑纪念馆文章
 *
 * @export
 * @param {JSON} data 纪念馆文章数据
 * @returns
 */
export function editHallArticle(data) {
  return request({
    url: '/Api/Personal/Hall/Article/Edit',
    method: 'POST',
    data: data
  })
}

/**
 * 删除纪念馆文章
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} id 文章id
 * @returns
 */
export function deleteHallArticle(hallId, id) {
  return request({
    url: `/Api/Personal/Hall/Article/Delete?hallId=${hallId}&id=${id}`,
    method: 'POST'
  })
}

/** 获取纪念馆待审核留言
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} pageIndex 当前页码
 * @param {number} pageSize 分页大小
 * @returns
 */
export function getHallMessageData(hallId, pageIndex = 1, pageSize = 10) {
  return request({
    url: `/Api/Personal/Hall/MsgBoard/List?hallId=${hallId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'POST'
  })
}

/**
 * 删除纪念馆留言
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} id 留言id
 * @returns
 */
export function deleteHallMessage(hallId, id) {
  return request({
    url: `/Api/Personal/Hall/MsgBoard/Delete?hallId=${hallId}&id=${id}`,
    method: 'POST'
  })
}

/**
 * 审核纪念馆留言
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} id 留言id
 * @param {string} status 审核状态Yes|No
 * @returns
 */
export function auditHallMessage(hallId, id, status) {
  return request({
    url: `/Api/Personal/Hall/MsgBoard/Audit?hallId=${hallId}&id=${id}&status=${status}`,
    method: 'POST'
  })
}

/**
 * 纪念馆留言审核设置
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {string} code 审核状态None|Part|Required
 * @returns
 */
export function setupHallMessage(hallId, code) {
  return request({
    url: `/Api/Personal/Hall/MsgBoard/Setup?hallId=${hallId}&code=${code}`,
    method: 'POST'
  })
}

/** 获取管理纪念馆相册
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {number} pageIndex 当前页码
 * @param {number} pageSize 分页大小
 * @returns
 */
export function getHallAlbumData(hallId, pageIndex = 1, pageSize = 10) {
  return request({
    url: `/Api/Personal/Hall/Photo/List?hallId=${hallId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'POST'
  })
}

/** 创建管理纪念馆相册
 *
 * @export
 * @param {number} hallId 纪念馆id
 * @param {string} name 相册名称
 * @param {string} info 相册简介
 * @param {string} coverUrl 封面图
 * @returns
 */
export function createHallAlbum(hallId, name, info, coverUrl) {
  return request({
    url: `/Api/Personal/Hall/Photo/Create?hallId=${hallId}&name=${name}&info=${info}&coverUrl=${coverUrl}`,
    method: 'POST'
  })
}

/** 编辑管理纪念馆相册
 *
 * @export
 * @param {number} id 相册id
 * @param {string} name 相册名称
 * @param {string} info 相册简介
 * @param {string} coverUrl 封面图
 * @returns
 */
export function editHallAlbum(id, name, info, coverUrl) {
  return request({
    url: `/Api/Personal/Hall/Photo/Edit?id=${id}&name=${name}&info=${info}&coverUrl=${coverUrl}`,
    method: 'POST'
  })
}

/** 删除管理纪念馆相册
 *
 * @export
 * @param {number} id 相册id
 * @returns
 */
export function deleteHallAlbum(id) {
  return request({
    url: `/Api/Personal/Hall/Photo/Delete?id=${id}`,
    method: 'POST'
  })
}

/** 管理纪念馆相册图片
 *
 * @export
 * @param {number} id 相册id
 * @returns
 */
export function getHallAlbumImageData(id) {
  return request({
    url: `/Api/Personal/Hall/Photo/Image?id=${id}`,
    method: 'POST'
  })
}

/** 添加纪念馆相册图片
 *
 * @export
 * @param {number} id 相册id
 * @param {string} title 图片标题名称
 * @param {string} imgUrl 图片
 * @returns
 */
export function addHallAlbumImage(id, title, imgUrl) {
  return request({
    url: `/Api/Personal/Hall/Photo/AddImage?id=${id}&title=${title}&imgUrl=${imgUrl}`,
    method: 'POST'
  })
}

/** 删除管理纪念馆图片
 *
 * @export
 * @param {number} id 图片id
 * @returns
 */
export function deleteHallAlbumImage(id) {
  return request({
    url: `/Api/Personal/Hall/Photo/DeleteImage?id=${id}`,
    method: 'POST'
  })
}

/** 获取讣告模板列表
 *
 * @export
 * @returns
 */
export function getObituaryTemplateList() {
  return request({
    url: '/Api/Personal/Hall/ObituaryTemplate/list',
    method: 'POST'
  })
}

/** 保存纪念馆讣告
 *
 * @export
 * @returns
 */
export function editObituary(data) {
  return request({
    url: 'Api/Personal/Hall/Obituary/Edit',
    method: 'POST',
    data
  })
}

/** 根据纪念馆id获取讣告
 *
 * @export
 * @returns
 */
export function findObituary(hallId) {
  return request({
    url: `Api/Personal/Hall/Obituary/Find?hallId=${hallId}`,
    method: 'POST'
  })
}
